import React, {Component} from 'react'

export default class about extends Component {
    render() {
        return (
            <section className="resume-section p-3 p-lg-5 d-flex align-items-center" id="about">
                <div className="w-100">
                    <h1 className="mb-0">Jose Antonio
                        <span className="text-primary">Reyes</span>
                    </h1>
                    <div className="subheading mb-5"> Santiago Rep. Dom, (809) 949-7898 ·
                        <a href="mailto:name@email.com">joseantonioreyes52@gmail.com</a>
                    </div>
                    <p className="lead mb-5">I am experienced in leveraging agile frameworks to provide
                        a robust synopsis for high level overviews. Iterative approaches to corporate
                        strategy foster collaborative thinking to further the overall value proposition.</p>
                    <div className="social-icons">
                        {/* <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                        </a> */}
                        <a href="https://github.com/josereyes52">
                            <i className="fab fa-github"></i>
                        </a>
                        <a href="https://www.instagram.com/josereyev/">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="https://www.facebook.com/josereyev">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                    </div>
                </div>
                <hr className="m-0"></hr>
            </section>
            
        )
    }
}
